import React from 'react';
import * as PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Header from '../containers/Header';
import Help from '../containers/Help';
import Notifications from '../containers/Notifications';
import FileManager from '../containers/FileManager';
import { LoadingFullScreen, LoadingModal } from '../components/Loading/Loading';
import Graphics from '../containers/Graphics';
import GameModal from '../containers/GameModal';
import TourHandler from '../containers/TourHandler';
import AriaLiveAnnouncer from '../containers/AriaLiveAnnouncer';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUndo,
  faTrash,
} from '@whitebox-learning/fontawesome-pro-regular-svg-icons';

library.add(faUndo, faTrash);

const App = ({
  panels,
  appLoading,
  unityLoading,
  loadingEnterTransition,
  showNavbar,
  showFileManager,
  showGameModal,
}) => (
  <div className="container-fluid p-0 d-flex flex-column flex-grow-1 position-relative main-content">
    <TransitionGroup component={null}>
      {appLoading && (
        <CSSTransition
          key="loading-app"
          classNames="fade"
          enter={loadingEnterTransition}
          timeout={500}
        >
          <LoadingFullScreen />
        </CSSTransition>
      )}
    </TransitionGroup>
    {showNavbar && <Header />}
    <div className="d-flex overflow-hidden flex-grow-1 position-relative" role="main">
      {panels}
      <Graphics />
      <Help />
    </div>
    <TransitionGroup component={null}>
      {showFileManager && (
        <CSSTransition classNames="fm-simple" timeout={250} key="file-manager">
          <FileManager />
        </CSSTransition>
      )}
      {showGameModal && (
        <CSSTransition classNames="fm-simple" timeout={250} key="game-mode">
          <GameModal />
        </CSSTransition>
      )}
    </TransitionGroup>
    <Notifications />
    <TourHandler />
    <AriaLiveAnnouncer />
  </div>
);

App.propTypes = {
  panels: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
  loading: PropTypes.bool,
  loadingEnterTransition: PropTypes.bool,
  unityLoading: PropTypes.bool,
  showNavbar: PropTypes.bool,
  moveChart: PropTypes.func,
};
App.defaultProps = {
  panels: [],
  loading: true,
  loadingEnterTransition: false,
  unityLoading: false,
  initialized: false,
  showNavbar: true,
};

export default App;
